import React, { useEffect, useState } from 'react';
import UploadFile from '../../../components/Request/UploadFile';
import RefrenceLink from '../../../components/Request/RefrenceLink';
import styles from './FullProduct.module.scss';
import cx from 'classnames';
import UploadedFiles from '../../../components/Request/UploadedFiles';
import { getFileFormData, setDefaultFiles, uploadRequestFile } from './helper';
import { requestsSelector, setCurrentRequestFilesSize, setLoading, setNextButtonEnabled } from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { apiDeleteRequestFile } from '../../../helpers/api';
import UploadFileWrapper from '../../../components/Request/UploadFileWrapper';
import { REQUEST_SUPPORTED_FILE_FORMATS } from '../../../constants/constants';

function OtherReferences({ isReadOnly, className }) {
  const [files, setFiles] = useState([]);
  const [links, setLinks] = useState([{ id: 1, value: '' }]);
  const _requestSelector = useSelector(requestsSelector);
  const dispatch = useDispatch();

  const handleFileChange = async (_files) => {
    const formData = getFileFormData(_files, _requestSelector.currentRequestId, 'referenceImages');

    dispatch(setLoading(true));
    await uploadRequestFile(formData, _files, files, setFiles, null, false, dispatch, _requestSelector);
    dispatch(setLoading(false));
  };

  const handleDeleteClick = async (_id) => {
    const _file = files.find((item) => item.id === _id)
    dispatch(setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize - _file.file.size));

    const _files = files.filter((item) => item.id != _id);
    setFiles(_files);
    await apiDeleteRequestFile(_id);
  };

  useEffect(async () => {
    if (_requestSelector?.currentRequestId){
      dispatch(setNextButtonEnabled(true));
      setDefaultFiles(_requestSelector.currentRequestId, 'referenceImages', setFiles);
      handlefetchLink()
    }
  }, []);

  const handlefetchLink = async () => {
    const _links = await setDefaultFiles(_requestSelector.currentRequestId, 'referenceLink');
    if (_links.results.length)
      setLinks(
        _links.results.map((_link) => ({
          ..._link,
          value: _link.link?.split('https://')?.at(-1),
          actual_id: _link.id,
        }))
      );
  }

  return (
    <div className={cx('px-3', className)}>
      <RefrenceLink
        title="Reference links"
        links={links}
        setLinks={setLinks}
        linkType="referenceLink"
        isReadOnly={isReadOnly}
        handlefetchLink={handlefetchLink}
      />
      <div className="p-3 bg-white">
        <h6>
          {isReadOnly && !files.length && (
            <>
              <span style={{ color: 'var(--primary-color)' }}>No </span> -{' '}
            </>
          )}
          Other files (pdf, xlsx, jpg, etc.)
        </h6>

        {/* <div className={cx('d-flex gap-3 p-3 flex-wrap', styles.uploadedFilesWrapper)}> */}

        <div
          className={cx('d-grid gap-3 py-3', styles.uploadedFilesWrapper)}
          style={
            files.length > 0
              ? {
                  gridTemplateColumns: 'repeat(auto-fill, minmax(215px, 1fr))',
                }
              : {}
          }>
          {!isReadOnly ? (
            <UploadFileWrapper fullWidth={!files.length}>
              <UploadFile
                className={
                  !files?.length ? cx(styles.fullWidth, styles.heightFiveHundread) : 'w-100 h-100'
                }
                subClassName={'h-100'}
                title="Drop and Down here"
                subtitle="or"
                allowed_files={REQUEST_SUPPORTED_FILE_FORMATS}
                onFileChange={handleFileChange}
                acceptMutipleFiles={true}
              />
            </UploadFileWrapper>
          ) : null}
          {files.map(
            (item, index) =>
              item.file && (
                <UploadedFiles
                  key={index}
                  _file={item}
                  onDeleteClick={() => handleDeleteClick(item.id)}
                  variant={2}
                  isReadOnly={isReadOnly}
                />
              )
          )}
        </div>
      </div>
    </div>
  );
}

export default OtherReferences;
